import { ITEM_DEFINITION_CODES } from '../../../../constants';

const sortByPhaseThenOrder = (a, b) =>
  a.phaseOrder === b.phaseOrder
    ? a.order - b.order
    : a.phaseOrder - b.phaseOrder;

export function getNextStepByOrder(steps = [], currentStepCode) {
  const sorted = [...steps].sort(sortByPhaseThenOrder);
  const currentIndex = sorted.findIndex(({ code }) => code === currentStepCode);
  // Gets the next index or wraps to the beginning of the list
  const nextIndex = (currentIndex + 1) % steps.length;

  return nextIndex === currentIndex ? {} : sorted[nextIndex] || {};
}

const PRIORITY_STEP = ITEM_DEFINITION_CODES.HOME_SERVICE_APP;
export function getPriorityStep(steps) {
  return (steps || []).find(({ code }) => code === PRIORITY_STEP);
}
